import { DomainApiModel } from './domain.model';
import { RoleApiModel } from './role.model';

export type UserApiModel = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
};

export type WithRoles = UserApiModel & { roles: RoleApiModel[] };

export type WithDomains = UserApiModel & { domains: DomainApiModel[] };

export enum UserRelationship {
  DOMAINS = 'DOMAINS',
  ROLES = 'ROLES',
}
